export default function OptimizerHero() {
  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNiIgc3Ryb2tlPSJyZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMDUpIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24 lg:py-32 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center bg-teal-500/20 border border-teal-500/30 rounded-full px-4 py-2 mb-6">
              <span className="iconify i-material-symbols:compress w-5 h-5 text-teal-400 mr-2" aria-hidden="true"></span>
              <span className="text-sm font-semibold text-teal-300">专业PDF优化工具</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              PDF Optimizer
            </h1>
            
            <p className="text-xl lg:text-2xl text-gray-300 mb-8 leading-relaxed">
              在不影响文档质量的前提下提升PDF性能
            </p>
            
            <p className="text-lg text-gray-400 mb-8 leading-relaxed">
              PDF Optimizer不仅仅是压缩文件大小，它是一个全面的PDF性能优化命令行工具。通过精细调整图像压缩选项、智能管理内容保留策略，让文档下载更快、打开更流畅、打印和归档更高效。
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <a 
                href="#pricing" 
                className="inline-flex items-center justify-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <span className="iconify i-material-symbols:download w-5 h-5 mr-2" aria-hidden="true"></span>
                免费试用
              </a>
              <a 
                href="#features" 
                className="inline-flex items-center justify-center bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold transition-all duration-200 border border-white/20 whitespace-nowrap cursor-pointer"
              >
                了解功能
              </a>
            </div>
            
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6">
              <div className="text-sm text-gray-400 mb-2">起始价格</div>
              <div className="flex items-baseline gap-2">
                <span className="text-4xl font-bold text-teal-400">¥20,843</span>
                <span className="text-lg text-gray-400">/年</span>
              </div>
              <div className="text-sm text-gray-400 mt-2">内部使用许可</div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative bg-gradient-to-br from-teal-500/20 to-cyan-500/20 backdrop-blur-sm border border-white/10 rounded-2xl p-8 shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/b6011a988c8e53c0ed9ae3b7e1db3195.jpg"
                alt="PDF Optimizer演示"
                className="w-full h-auto rounded-lg shadow-lg"
              />
              <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white rounded-xl p-4 shadow-xl">
                <div className="flex items-center gap-3">
                  <span className="iconify i-material-symbols:speed w-8 h-8" aria-hidden="true"></span>
                  <div>
                    <div className="text-2xl font-bold">70%</div>
                    <div className="text-sm opacity-90">文件大小减少</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
